// Feature keys for RBAC
export const FEATURE_KEYS = [
  'dashboard',
  'library',
  'pantry',
  'planner',
  'orders',
  'analytics',
  'reports',
  'settings',
  'starter_pack',
] as const;

export type FeatureKey = typeof FEATURE_KEYS[number];

// Debounce delays (in milliseconds)
export const DEBOUNCE = {
  SEARCH: 300,
  AUTOSAVE_COSTING: 1000,
  AUTOSAVE_GENERAL: 2000,
} as const;

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 12,
  RECIPES_PAGE_SIZE: 12,
  INGREDIENTS_PAGE_SIZE: 12,
  MATERIALS_PAGE_SIZE: 12,
  EQUIPMENT_PAGE_SIZE: 12,
} as const;

// Toast durations (in milliseconds)
export const TOAST = {
  DEFAULT_DURATION: 5000,
  ERROR_DURATION: 7000,
  SUCCESS_DURATION: 3000,
} as const;

// File upload limits
export const UPLOAD = {
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_CSV_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  ALLOWED_CSV_TYPES: ['text/csv', 'application/vnd.ms-excel'],
} as const;

// API endpoints (base paths)
export const API = {
  RECIPES: '/api/recipes',
  INGREDIENTS: '/api/ingredients',
  MATERIALS: '/api/materials',
  EQUIPMENT: '/api/equipment',
  CHEFAIQ: '/api/chefaiq-recipes',
  TBA: '/api/tba-recipes',
  ORDERS: '/api/orders',
  PLANNER: '/api/planner',
  SHOPPING_LIST: '/api/shopping-list',
  INVENTORY: '/api/inventory',
  WORKSPACES: '/api/workspaces',
  AUTH: '/api/auth',
} as const;

// Recipe defaults
export const RECIPE = {
  DEFAULT_SERVINGS: 1,
  DEFAULT_PREP_TIME: 0,
  DEFAULT_COOK_TIME: 0,
  MIN_SERVINGS: 1,
  MAX_SERVINGS: 1000,
} as const;

// Costing defaults
export const COSTING = {
  DEFAULT_MARKUP: 0,
  DEFAULT_LABOR_COST: 0,
  DEFAULT_OVERHEAD: 0,
  MIN_MARKUP: 0,
  MAX_MARKUP: 1000,
} as const;

// Validation
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 8,
  MAX_NAME_LENGTH: 100,
  MAX_DESCRIPTION_LENGTH: 500,
  MAX_NOTES_LENGTH: 1000,
} as const;

export const CHAT_SESSION_KEYS = {
  CONVERSATION_ID: 'chat_conversation_id',
  OPEN: 'chat_open',
} as const;
